// Do not use outside of its respective selector
import { createSelector } from 'reselect'
import { DialogId } from '@feedyou/schema'

import {
  buildDialogHierarchyMap,
  DialogHierarchyMap,
  getDirectEnabledSubdialogsForDialog,
  getDirectSubdialogsForDialog,
  getUsedDialogsPerTreeEntryPoint
} from '../../../features/dialogRelation'
import { dialogsArraySelector } from './dialogsArraySelector'
import { memoizeByRefAndId } from '../../../lib/performance/memoizeByRefAndId'
import { RootState } from '../../../reducers'
import { botFlowSelector } from './botFlowSelector'

const getDirectSubdialogsForDialogMemoized = memoizeByRefAndId(getDirectSubdialogsForDialog)
const getDirectEnabledSubdialogsForDialogMemoized = memoizeByRefAndId(
  getDirectEnabledSubdialogsForDialog
)

const dialogChildMapSelector = createSelector(dialogsArraySelector, dialogsArray => {
  const result = new Map<DialogId, Set<DialogId>>()

  dialogsArray.forEach(dialog => {
    result.set(dialog.id, getDirectSubdialogsForDialogMemoized(dialog))
  })

  return result
})

const dialogEnabledChildMapSelector = createSelector(dialogsArraySelector, dialogsArray => {
  const result = new Map<DialogId, Set<DialogId>>()

  dialogsArray.forEach(dialog => {
    result.set(dialog.id, getDirectEnabledSubdialogsForDialogMemoized(dialog))
  })

  return result
})

export const dialogHierarchyMapSelector = createSelector(
  dialogChildMapSelector,
  dialogEnabledChildMapSelector,
  botFlowSelector,
  (childMap, enabledConnectionsChildMap, flow): DialogHierarchyMap => {
    return buildDialogHierarchyMap(
      childMap,
      enabledConnectionsChildMap,
      flow ? getUsedDialogsPerTreeEntryPoint(flow) : {}
    )
  }
)

export function dialogHierarchyDescriptorSelector(id: DialogId) {
  return function dialogHierarchyDescriptorSelector(state: RootState) {
    return dialogHierarchyMapSelector(state).get(id)
  }
}
